import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import DdtService from 'services/DdtService';
import fetch from "../../auth/GenericFetchInterceptorV5";

const initialState = {
  loadingList: false,
  loadedList: false,
  errorList: false,
  creating: false,
  errorCreate: false,
  ddt: [],
};

export const loadDdt = createAsyncThunk('ddt/load', async (_, { rejectWithValue }) => {
  try {
    const res = await DdtService.list();
    return res.data;
  } catch (e) {
    return rejectWithValue(e.message || 'Errore caricamento DDT');
  }
});

export const createDdt = createAsyncThunk('ddt/create', async (payload, { rejectWithValue }) => {
  try {
      const res = await DdtService.create(payload.body,payload.companyId);
      return res.order;
  } catch (e) {
    return rejectWithValue(e.status || 500);
  }
});

export const createMdsDdt = createAsyncThunk('ddt/mds/create', async (payload, { rejectWithValue }) => {
    try {
        const res = await DdtService.createMds(payload.body,payload.companyId);
        return res.order;
    } catch (e) {
        return rejectWithValue(e.status || 500);
    }
});

const ddtSlice = createSlice({
  name: 'ddt',
  initialState,
  reducers: {
    resetDdtState: () => initialState,
  },
  extraReducers: builder => {
    builder
      .addCase(loadDdt.pending, state => {
        state.loadingDdt = true;
        state.errorDdt = false;
      })
      .addCase(loadDdt.fulfilled, (state, action) => {
        state.loadingDdt = false;
        state.loadedDdt = true;
        state.errorDdt = false;
        state.ddt = Array.isArray(action.payload) ? action.payload : [];
      })
      .addCase(loadDdt.rejected, state => {
        state.loadingDdt = false;
        state.loadedDdt = true;
        state.errorDdt = true;
        state.ddt = [];
      })
      .addCase(createDdt.pending, state => {
        state.creatingDdt = true;
        state.errorCreate = false;
      })
      .addCase(createMdsDdt.pending, state => {
        state.creatingDdt = true;
        state.errorCreate = false;
      })
      .addCase(createDdt.fulfilled, (state, action) => {
        state.creatingDdt = false;
        state.errorCreateDdt = false;
        state.ddt = [action.payload, ...state.ddt];
      })
     .addCase(createMdsDdt.fulfilled, (state, action) => {
        state.creatingDdt = false;
        state.errorCreateDdt = false;
        state.ddt = [action.payload, ...state.ddt];
     })
     .addCase(createDdt.rejected, state => {
        state.creatingDdt = false;
        state.errorCreateDdt = true;
     })
     .addCase(createMdsDdt.rejected, state => {
        state.creatingDdt = false;
        state.errorCreateDdt = true;
     });
  }
});

export const { resetDdtState } = ddtSlice.actions;
export default ddtSlice.reducer;

